module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                    \"paging\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"filtering\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"sorting\": {\r\n                                    \"enabled\": true\r\n                                    }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date Activated")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Contract")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_contract_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNpro")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_contract_cnpro_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Service Charge")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_set_service_charge) + " %")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Labour Cost")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_labour_cost))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Amount To Pay")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.payment.contract_money_pay_out_amount))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_status))])]), _vm._v(" "), (_vm.payment.contract_money_paid_date) ? _c('tr', [_c('th', [_vm._v("Date Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payment.contract_money_paid_date))])]) : _vm._e(), _vm._v(" "), (_vm.payment.contract_money_status_id != 9) ? _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.payMoney
    }
  }, [_vm._v("Pay Money")]), _vm._v("  ")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("Payments")]), _vm._v(" "), (_vm.payments) ? _c('h3', [_vm._v(_vm._s(_vm.payments.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         Payments Requests  \r\n        ")]), _vm._v(" "), _c('div', [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.payments), function(payment, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.contract_money_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.contract_money_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.contract_money_contract_cnpro_name))]), _vm._v(" "), _c('td', {
      style: ({
        background: payment.contract_money_status_color,
        color: '#fff',
        padding: '0.4em'
      })
    }, [_vm._v(_vm._s(payment.contract_money_status))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', payment)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    Payment Details\r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "payments"
    }
  }, [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Activated:")]), _vm._v("(Contract has ended, Money is available)")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Pending:")]), _vm._v("(CNpro has requested For Money)")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Paid:")]), _vm._v("(Cityneeds has paid CNpro)")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-money-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v(" Activated:")]), _vm._v("(Contract has ended, Money is available)")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(" Pending:")]), _vm._v("(CNpro has requested For Money)")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(" Paid:")]), _vm._v("(Cityneeds has paid CNpro)")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("REF.")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("CNpro")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md",
      "data-title": "DOB"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c58ed7b6"}!./src/components/Payments/template.html
// module id = 169
// module chunks = 0